import { render, staticRenderFns } from "./creative-preview.vue?vue&type=template&id=38319790&scoped=true"
import script from "./creative-preview.vue?vue&type=script&lang=js"
export * from "./creative-preview.vue?vue&type=script&lang=js"
import style0 from "./creative-preview.vue?vue&type=style&index=0&id=38319790&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38319790",
  null
  
)

export default component.exports